const getterMap = new WeakMap();
const setterMap = new WeakMap();

export {
	getterMap,
	setterMap
};
